import { Grid } from "@mui/material"
import GaugeChart from "./GaugeChart"
import LineChartMalaria from "./LineChart"
import SpiderChart from "./SpiderChart"
import HIVBarChart from "./HIVBarChart"
import HIVTBBarChart from "./HIVTBBarChart"
import TBBarChart from "./TBBarChart"

export default function DiseaseBurdenCharts({ stats, disease_selection }) {
  const { neo_stats, mmr_stats, ydr_stats } = stats

  if (disease_selection === 0) {
    return (
      <Grid container sx={{ height: "100%", width: "100%" }}>
        <Grid item xs={6}>
          <GaugeChart
            gauge_value_middle={neo_stats.mean}
            gauge_value_high={neo_stats.max}
            needle_value={neo_stats.value}
            width={380}
            height={125}
            x_pos={3}
            y_pos={1.2}
            title={"Neonatal death in facility rate"}
            min_value={neo_stats.min}
            max_value={neo_stats.max}
          />
        </Grid>
        <Grid item xs={6}>
          <GaugeChart
            gauge_value_middle={mmr_stats.mean}
            gauge_value_high={mmr_stats.max}
            needle_value={mmr_stats.value}
            width={380}
            height={125}
            x_pos={3}
            y_pos={1.2}
            title={"Maternal mortality in facility ratio"}
            min_value={mmr_stats.min}
            max_value={mmr_stats.max}
          />
        </Grid>
      </Grid>
    )
  }
  if (disease_selection === 1) {
    return (
      <Grid container sx={{ height: "100%", width: "100%" }}>
        <Grid item xs={12}>
          <GaugeChart
            gauge_value_middle={ydr_stats.mean}
            gauge_value_high={ydr_stats.max}
            needle_value={ydr_stats.value}
            width={380}
            height={125}
            x_pos={1.5}
            y_pos={1.2}
            title={"Delivery in 10-19 years in facility rate"}
            min_value={ydr_stats.min}
            max_value={ydr_stats.max}
          />
        </Grid>
      </Grid>
    )
  }
  if (disease_selection === 2) {
    return (
      <div style={{ height: 235, width: 510 }}>
        <LineChartMalaria stats={stats} />
      </div>
    )
  }
  if (disease_selection === 3) {
    return (
      <div style={{ height: 235, width: 510 }}>
        <SpiderChart stats={stats} />
      </div>
    )
  }
  if (disease_selection === 4) {
    return (
      <div style={{ height: 235, width: 510 }}>
        <HIVBarChart stats={stats} />
      </div>
    )
  }
  if (disease_selection === 5) {
    return (
      <div style={{ height: 235, width: 510 }}>
        <HIVTBBarChart stats={stats} />
      </div>
    )
  }
  if (disease_selection === 6) {
    return (
      <div style={{ height: 235, width: 510 }}>
        <TBBarChart stats={stats} />
      </div>
    )
  }
}
